import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  width: '100%',
  minWidth: 0
};

const clamped: SxProps<Theme> = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  whiteSpace: 'normal'
};

const expanded: SxProps<Theme> = {
  whiteSpace: 'normal'
};

const missing: SxProps<Theme> = {
  fontStyle: 'italic',
  color: 'text.secondary',
  whiteSpace: 'normal'
};

const seeMore: SxProps<Theme> = {
  mt: 0.5,
  fontSize: 'inherit',
  cursor: 'pointer',
  textDecoration: 'none',
  color: 'primary.main',
  '&:hover': {
    textDecoration: 'underline'
  }
};

export const candidateProfileExplanationCellSx = {
  container,
  clamped,
  expanded,
  missing,
  seeMore
};
